<template>
  <div class="input_number_wrapper">
    <button class="btn_minus" @click.stop="reduceNum">-</button>
    <input type="text" v-model="showNum" @input="changeNum" class="number_text" />
    <button class="btn_plus" @click.stop="addNum">+</button>
  </div>
</template>

<script>
export default {
  name: 'InputNumber',
  data () {
    return {
      showNum: 1
    }
  },
  props: ['num', 'max', 'tip','spec'],
  created() {
    this.showNum = this.num;
  },
  methods: {
    checkRate(value) {
      if(value.length == 1) {
        value = (value.toString()).replace(/[^1-9]/g, '')
      } else {
        value = (value.toString()).replace(/\D/g, '')
      }

      return value;
    },
    judge (num) {
      //如果是秒杀商品，购买数量只能是1
      //if(typeof this.spec !== 'undefined'){
      //  if(typeof this.spec.is_skill !== 'undefined' && this.spec.is_skill==1){
      //    this.$message.error('秒杀商品仅能购买一个');
      //    this.$emit('changeCartNum',1);
      //    return 1;
      //  }
      //}
      

      if (this.max && num >= this.max) {
        this.$message.warning(this.tip + this.max);
        num = this.max;
      }

      this.$emit('changeCartNum',num);
      return num;
    },
    changeNum () {
      if(isNaN(parseInt(this.showNum))){
        this.showNum = 1;
      }

      if(parseInt(this.showNum)==0){
        this.showNum = 1;
      }

      // if(typeof this.showNum != 'number'){
      //   this.showNum = 1;
      // }
      // if(this.showNum <=0){
      //   this.showNum = 1;
      // }

      this.showNum = this.judge(this.checkRate(this.showNum));
    },
    addNum () {
      this.showNum = this.judge(parseInt(this.showNum) + 1);
    },
    reduceNum () {
      this.showNum = this.judge(parseInt(this.showNum) - 1 <= 1 ? 1 : parseInt(this.showNum) - 1);
    }
  }
}
</script>

<style scoped>
.number_text{
  width:50px;
  text-align:center;
  border:1px solid #dedede;
  border-radius: unset;
  border-right:0;
  border-left:0;
  height:30px;
  outline: 0;
}
.input_number_wrapper {
  display: inline-flex;
  flex-wrap: nowrap;
}
.btn_minus {
  width:30px;
  cursor: pointer;
  border:1px solid #dedede;
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
  background:#fff;
  font-size:24px;
  height:30px;
  line-height:15px;
}
.btn_plus {
  width:30px;
  cursor: pointer;
  border:1px solid #dedede;
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
  background:#fff;
  font-size:24px;
  height:30px;
  line-height:20px;
}
</style>



// WEBPACK FOOTER //
// src/components/common/InputNumber.vue